<div class="container" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%;">
        <!--Header-->
        <div class="modal-header">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="row">
                    <div class="col-md-6 col-6 col-6" style="padding-left: 0px;">
                        <h4 class="modal-title"><span id="ApntmntHdr">Create Report Form</span></h4>
                    </div>
                    <div class="col-md-6 col-6 col-6" style="padding: 0px; text-align: right;">
                        <span class="yellowBckIcn" style="margin-right: 10px;">
                            <i class="zmdi zmdi-copy" aria-hidden="true"></i>
                        </span>
                        <span class="btn btn-save" style="margin-right: 10px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i>
                            <span>Save</span>
                        </span>
                        <span>
                            <i class="closeMdl zmdi zmdi-close redBckIcn" style="float: right;"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!--Body-->
        <div class="modal-body" style="margin: 0px;">
            <!--Title-->
            <div class="col-md-12 col-12 pad0" style="margin-top: 5px;">
                <input type="text" name="title" [(ngModel)]="data.rptTitle" id="vNO" placeholder="Report Title" class="form-control" tabindex="1">
            </div>

            <!--Description-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0itm pad0" style="margin-top: 20px;">
                <textarea type="text" tabindex="1" class="form-control supCls" placeholder="Description" style="padding: 3px; height: 60px; resize: none; border-radius: 10px!important; padding: 10px;" [(ngModel)]="data.description"></textarea>
            </div>

            <!--Fields-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0itm pad0" style="margin-top: 20px; border: 1px solid #ddd; border-radius: 10px;">
                <div class="col-md-12 col-sm-12 col-xs-12 orangeText" style="padding: 10px;">
                    Fields
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 10px; margin-bottom: 20px;">
                   <div class="row" style="margin: 0px;">
                       <!--Field Title-->
                       <div class="col-md-4 col-12" style="padding: 0px;">
                           <input type="text" name="ftitle" [(ngModel)]="fieldData.title" id="titleID" placeholder="Field Title" class="form-control" tabindex="1">
                       </div>

                       <!--Type-->
                       <div class="col-md-3 col-12">
                           <select class="form-control" style="box-shadow: none;" [(ngModel)]="fieldData.type" tabindex="1">
                               <option value="0" style="color: #777;">Select Type</option>
                               <option value="{{a.type}}" *ngFor="let a of types;">{{a.type}}</option>
                           </select>
                       </div>

                       <!--Min-->
                       <div class="col-md-2 col-12" [hidden]="fieldData.type == 'Text'">
                           <input type="text" name="min" [(ngModel)]="fieldData.min" id="minID" placeholder="Min." class="form-control" tabindex="1" (keypress)="numberOnly($event)">
                       </div>

                       <!--Max-->
                       <div class="col-md-2 col-12" [hidden]="fieldData.type == 'Text'">
                           <input type="text" name="max" [(ngModel)]="fieldData.max" id="maxID" placeholder="Max." class="form-control" tabindex="1" (keypress)="numberOnly($event)">
                       </div>

                       <!--Add-->
                       <div class="col-md-1 col-12" (click)="addFields()">
                          <i class="fa fa-plus orangeText"></i>
                       </div>
                   </div>
                </div>

                <!--List-->
                <div class="row" style="margin: 0px;">
                    <div class="col-md-12 col-sm-12 col-xs-12" *ngFor="let a of fields;" style="padding: 10px; border: 1px solid #ddd; border-radius: 10px;">
                        {{a.fieldTitle}}
                    </div>
                </div>
                
            </div>
        </div>

        <!--Footer-->
        <div class="modal-footer col-md-12 col-sm-12 col-xs-12" style="border: none; text-align: left; float: left; justify-content: left !important; padding: 20px 15px;">
            <span class="btn btn-save">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>

    </div>
</div>
